import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';

export default function useTrackCardEvents() {
  const trackCopyDebitCardDetailsPressed = useButtonPressedCallback({
    elementName: 'copy_dc_details',
    elementText: 'Copy',
    appPageName: 'debit_card_modal'
  });

  const clickCopyTracker = () => {
    trackCopyDebitCardDetailsPressed();
  };

  return { clickCopyTracker };
}
